// Api/Gebruikers/Controlsherm/index.js

import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    USER_DETAILS: {
        url: "controlscreen/details",
        method: "get",
    },

    DATES: {
        url: "controlscreen",
        method: "get",
    },

    NOTES: {
        url: "controlscreen/notes",
        method: "post",
    },

    ASSIGN: {
        url: "controlscreen/assign",
        method: "patch",
    },

    USER_NOTES: (gebruikerId, subsId, contractId, selectedDates) => ({
        url: `controlscreen/notes/${gebruikerId}/${subsId}`,
        method: "get",
        params: {
            substitutionDayIds: selectedDates,
            contractId,
        },
    }),
};

export const useUserDetails = (
    gebruikerId,
    subsId,
    dayId,
    contractId
) =>
    useApiFetcherSWR(
        gebruikerId && subsId && dayId && contractId
            ? {
                url: `${API_ENDPOINT.USER_DETAILS.url}/${gebruikerId}`,
                method: "get",
                params: {
                    substitutionId: subsId,
                    substitutionDayId: dayId,
                    contractId,
                },
            }
            : null
    );

export const useDates = (userId, substId, dayId, ctId) =>
    useApiFetcherSWR(
        userId && substId && dayId && ctId
            ? {
                  url: `${API_ENDPOINT.DATES.url}/${userId}/${substId}`,
                  method: "get",
                  params: {
                      substitutionDayId: dayId,
                      contractId: ctId,
                  },
              }
            : null,
        {
            revalidateOnMount: true,
            revalidateOnFocus: false,
            revalidateOnReconnect: true,
            shouldRetryOnError: false,
            dedupingInterval: 0,
        }
    );

export const useUserNotes = (
    gebruikerId,
    subsId,
    contractId,
    selectedDates
) =>
    useApiFetcherSWR(
        gebruikerId &&
            subsId &&
            contractId &&
            selectedDates?.length
            ? API_ENDPOINT.USER_NOTES(
                gebruikerId,
                subsId,
                contractId,
                selectedDates
            )
            : null
    );
export const useAssignSubstitutor = () =>
    useApiFetcherSWR(API_ENDPOINT.ASSIGN);